import { render, staticRenderFns } from "./DataVisualisation.vue?vue&type=template&id=e01c3df6&scoped=true"
import script from "./DataVisualisation.vue?vue&type=script&lang=js"
export * from "./DataVisualisation.vue?vue&type=script&lang=js"
import style0 from "./DataVisualisation.vue?vue&type=style&index=0&id=e01c3df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01c3df6",
  null
  
)

export default component.exports